
<p-confirmDialog />

<div class="card">
  <div class="card-content">
    <div class="stats-cards-row">
      <div class="stats-card stats-card--total">
        <div class="stats-card-main">
          <span class="stats-card-value">{{ totalDesignationsCount }}</span>
          <span class="stats-card-label">Total Designations</span>
          <span class="stats-card-sublabel">All designations</span>
        </div>
        <div class="stats-card-icon"><i class="pi pi-id-card"></i></div>
      </div>
      <div class="stats-card stats-card--success">
        <div class="stats-card-main">
          <span class="stats-card-value">{{ activeDesignationsCount }}</span>
          <span class="stats-card-label">Active</span>
          <span class="stats-card-sublabel">Currently active</span>
        </div>
        <div class="stats-card-icon"><i class="pi pi-check-circle"></i></div>
      </div>
      <div class="stats-card stats-card--danger">
        <div class="stats-card-main">
          <span class="stats-card-value">{{ inactiveDesignationsCount }}</span>
          <span class="stats-card-label">Inactive</span>
          <span class="stats-card-sublabel">Not active</span>
        </div>
        <div class="stats-card-icon"><i class="pi pi-minus-circle"></i></div>
      </div>
      <div class="stats-card stats-card--total">
        <div class="stats-card-main">
          <span class="stats-card-value">{{ totalRecords }}</span>
          <span class="stats-card-label">Showing</span>
          <span class="stats-card-sublabel">After filters</span>
        </div>
        <div class="stats-card-icon"><i class="pi pi-list"></i></div>
      </div>
    </div>

    <div class="filter-bar filter-bar-collapsible mb-4" [class.filter-bar-visible]="pageHeaderService.currentFiltersVisible">
      <div class="filter-bar-filters">
        <div class="filter-field">
          <label for="statusFilter" class="filter-label">Status</label>
          <p-select id="statusFilter" [(ngModel)]="selectedStatusFilter" (ngModelChange)="onStatusFilterChange()"
            [options]="statusFilterOptions" optionLabel="label" optionValue="value" placeholder="All"
            [showClear]="true" [filter]="true" filterPlaceholder="Search status..."
            panelStyleClass="filter-dropdown-panel" appendTo="body" />
        </div>
      </div>
      <div class="filter-bar-actions" *ngIf="hasActiveFilters()">
        <button type="button" class="btn-clear-filters" (click)="clearFilters()" title="Clear all filters">
          <i class="pi pi-filter-slash"></i>
        </button>
      </div>
    </div>

    <p-table
      [scrollable]="true"
      scrollHeight="flex"
      [value]="filteredDesignations"
      [loading]="loading"
      [paginator]="true"
      [alwaysShowPaginator]="false"
      [rows]="rows"
      [totalRecords]="totalRecords"
      [first]="first"
      [rowsPerPageOptions]="rowsPerPageOptions"
      [showCurrentPageReport]="true"
      currentPageReportTemplate="Showing {first} to {last} of {totalRecords} designations"
      [tableStyle]="{ 'min-width': '100%' }"
      styleClass="p-datatable no-column-lines">
      <ng-template pTemplate="header">
        <tr>
          <th pSortableColumn="name">
            Name
            <p-sortIcon field="name" />
          </th>
          <th pSortableColumn="description">
            Description
            <p-sortIcon field="description" />
          </th>
          <th class="th-actions">Actions</th>
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-designation>
        <tr [class.row-inactive]="designation.isActive === false">
          <td class="td-truncate" [pTooltip]="designation.name || '-'" tooltipPosition="top">{{ designation.name }}</td>
          <td class="td-truncate td-description" [pTooltip]="(designation.description || '-')" tooltipPosition="top">{{ designation.description || '-' }}</td>
          <td class="table-cell-actions">
            <div class="table-actions-stack">
              <p-button
                [icon]="designation.isActive ? 'pi pi-check-circle' : 'pi pi-times-circle'"
                [severity]="designation.isActive ? 'success' : 'secondary'"
                [text]="true"
                (onClick)="toggleActiveStatus(designation)"
                size="small"
                [pTooltip]="designation.isActive ? 'Active' : 'Inactive'"
                tooltipPosition="top" />
              <p-button
                icon="pi pi-pencil"
                (onClick)="showEditDialog(designation)"
                [text]="true"
                severity="info"
                size="small"
                pTooltip="Edit"
                tooltipPosition="top" />
            </div>
          </td>
        </tr>
      </ng-template>

      <ng-template pTemplate="emptymessage">
        <tr class="table-empty-row">
          <td colspan="3" class="table-empty-cell">
            <div class="empty-state">
              <div class="empty-icon"><i class="pi pi-inbox"></i></div>
              <p class="empty-message">No designations found</p>
              <p class="empty-description">Update filters or add a new designation</p>
            </div>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</div>

<p-dialog [visible]="displayDialog" (visibleChange)="displayDialog = $event"
  [header]="dialogMode === 'add' ? 'Add Designation' : 'Edit Designation'"
  [modal]="true" styleClass="dialog-md" [dismissableMask]="true" [closable]="true">

  <div class="form-dialog-form form-dialog-compact">
    <div class="form-dialog-container">
      <div class="form-row">
        <div class="field" [class.field-invalid]="fieldTouched['name'] && !selectedDesignation.name.trim()">
          <label for="name">Name <span class="required-star">*</span></label>
          <input pInputText id="name" [(ngModel)]="selectedDesignation.name"
            placeholder="Enter designation name" (blur)="fieldTouched['name'] = true" />
          <small class="field-error" *ngIf="fieldTouched['name'] && !selectedDesignation.name.trim()">Name is required</small>
        </div>
      </div>
      <div class="form-row">
        <div class="field">
          <label for="description">Description</label>
          <textarea id="description" [(ngModel)]="selectedDesignation.description" rows="3"
            class="p-inputtext" placeholder="Enter designation description"></textarea>
        </div>
      </div>
      <div class="form-row" *ngIf="dialogMode === 'edit'">
        <div class="field">
          <label>Status</label>
          <p-button [label]="selectedDesignation.isActive ? 'Active' : 'Inactive'"
            [severity]="selectedDesignation.isActive ? 'success' : 'secondary'"
            [outlined]="!selectedDesignation.isActive"
            (onClick)="selectedDesignation.isActive = !selectedDesignation.isActive" size="small" />
        </div>
      </div>
    </div>
  </div>

  <ng-template pTemplate="footer">
    <div class="form-dialog-footer-btns">
      <p-button label="Reset" icon="pi pi-refresh" (onClick)="resetDesignationForm()" [text]="true" severity="secondary"
        styleClass="btn-form-reset" />
      <p-button label="Cancel" icon="pi pi-times" (onClick)="hideDialog()" severity="secondary" [outlined]="true" />
      <p-button label="Save" icon="pi pi-check" (onClick)="saveDesignation()" severity="primary" />
    </div>
  </ng-template>
</p-dialog>
